/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { h } from 'preact';

const styles = {
  toggleSwitch: css`
    position: relative;
    display: inline-block;
    width: 33px;
    height: 18px;
  `,
  toggleInput: css`
    opacity: 0;
    width: 15px;
    height: 15px;
  `,
  toggleSlider: css`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #3b3b3b;
    transition: 0.4s;
    border-radius: 34px;

    &:before {
      position: absolute;
      content: '';
      height: 15px;
      width: 15px;
      left: 0px;
      bottom: 2px;
      background-color: white;
      transition: 0.4s;
      border-radius: 50%;
    }
  `,
  toggleSliderActive: css`
    background-color: #6a3de8;

    &:before {
      transform: translateX(18px);
    }
  `
};

export const Toggle = ({
  enableAutoDeduct,
  toggleEnableAutoDeduct
}: {
  enableAutoDeduct: boolean;
  toggleEnableAutoDeduct: () => void;
}) => {
  return (
    <label css={styles.toggleSwitch}>
      <input
        css={styles.toggleInput}
        type="checkbox"
        checked={enableAutoDeduct}
        onChange={toggleEnableAutoDeduct}
      />
      <span css={[styles.toggleSlider, enableAutoDeduct && styles.toggleSliderActive]}></span>
    </label>
  );
};
